import { render, staticRenderFns } from "./BondStatisticsCardShimmer.vue?vue&type=template&id=bbb6d870&"
import script from "./BondStatisticsCardShimmer.vue?vue&type=script&lang=js&"
export * from "./BondStatisticsCardShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
